import { usePermission } from "app/hooks/usePermission";
import { PermissionLevel } from "app/zustand/assistantPermissionsStore";

// Everything on a proposal is governed by PIPELINE.PENDING_UNDERWRITING alone - both the write
// actions (approve, comment, revoke, request changes) and whether the page is locked behind the
// NONE overlay - regardless of where the proposal was opened from.
export function useProposalPermissionLevel(): PermissionLevel {
  const { level } = usePermission("PIPELINE.PENDING_UNDERWRITING");
  return level;
}

// Kept as its own name so the page lock and the write actions can diverge again later without
// touching every call site.
export function useProposalLockLevel(): PermissionLevel {
  return useProposalPermissionLevel();
}

export default useProposalPermissionLevel;
